import { render, staticRenderFns } from "./productManifactureType.vue?vue&type=template&id=c1a628cc&"
import script from "./productManifactureType.vue?vue&type=script&lang=js&"
export * from "./productManifactureType.vue?vue&type=script&lang=js&"
import style0 from "./productManifactureType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports